<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <SelectorDestino></SelectorDestino>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import SelectorDestino from '../components/SelectorDestino.vue';
export default {
    name: 'TargetView',
    components: {
        ColumnaIzquierda,
        SelectorDestino,
    }
}
</script>